import { Injectable } from "@angular/core";
import * as FileSaver from "file-saver";
import * as ExcelJS from 'exceljs';
import * as XLSX from 'xlsx';



const EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
const EXCEL_TYPE_UTF = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const EXCEL_EXTENSION = ".xlsx";

@Injectable()
export class ExcelService {

  constructor() { }

  public async exportAsExcelFile(columns: string[], dataset: any[], title?: string, headerImage?: string, date?: Date, config?: ExcelConfig): Promise<void> {
    const workbook = new ExcelJS.Workbook();
    workbook.creator = config ? config.creator : undefined;
    workbook.lastModifiedBy = config ? config.lastModifiedBy : undefined;
    workbook.created = new Date();
    workbook.modified = new Date();
    workbook.lastPrinted = new Date();
    const worksheet = workbook.addWorksheet(config && config.worksheetName ? config.worksheetName : 'Worksheet 1');
    let headerRowNumber: number = 1;



      worksheet.views = config && config.views ? config.views : [
        { state: 'frozen', xSplit: 0, ySplit: 0 }
      ];
    

    const headerRow = worksheet.getRow(headerRowNumber);
    headerRow.values = columns;
    headerRow.height = 30;
    headerRow.alignment = {
      wrapText: true,
      horizontal: 'center',
      vertical: 'middle'
    };
    headerRow.font = {
      bold: true,
      size: 12
    };



    /** DATA ROWS */
    const rows = dataset.map(o => {
      return Object.keys(o).map(key => {
        return o[key];
      });
    });
    worksheet.addRows(rows);
    
    /** EXPORT */
    const data: any = await workbook.xlsx.writeBuffer();
    const blob = new Blob([data], { type: EXCEL_TYPE });
    FileSaver.saveAs(
      blob,
      `${config && config.worksheetName ? config.worksheetName : 'Worksheet 1'}` + "_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  public async readExcelData(file: File): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      try {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          var arraybuffer = e.target.result;

          var data = new Uint8Array(arraybuffer);
          var arr = new Array();
          for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
          var bstr = arr.join("");
          var workbook = XLSX.read(bstr, { type: "binary" });

          var first_sheet_name = workbook.SheetNames[0];
          var worksheet = workbook.Sheets[first_sheet_name];

          const excelData = XLSX.utils.sheet_to_json(worksheet, { raw: true });
          resolve(excelData)
        }

        reader.readAsArrayBuffer(file);
      } catch (error) {
        console.warn(error);
        reject(error);
      }
    })
  }

  public alphabet(): Array<string> {
    return 'abcdefghijklmnopqrstuvwxyz'.split('');
  }
  public async readTextData(file: File): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      try {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          var arraybuffer = e.target.result;

          var data = new Uint8Array(arraybuffer);
          var arr = new Array();
          for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
          var bstr = arr.join("");
          var workbook = XLSX.read(bstr, { type: "binary" });

          var first_sheet_name = workbook.SheetNames[0];
          var worksheet = workbook.Sheets[first_sheet_name];

          const excelData = XLSX.utils.sheet_to_json(worksheet, { raw: true });
          resolve(excelData)
        }

        reader.readAsArrayBuffer(file);
      } catch (error) {
        console.warn(error);
        reject(error);
      }
    })
  }



  public async getDocumentDefinition(columns: string[], dataset: any[], title?: string, headerImage?: string, date?: Date): Promise<any> {
    // sessionStorage.setItem('resume', JSON.stringify(this._transactionList));
    return {
      pageOrientation: 'landscape',
      pageSize: 'A4',//A0
      content: [
        {
          text: title,
          bold: true,
          fontSize: 14,
          alignment: 'center',
          margin: [0, 0, 0, 10]
        },
        {
          text: title,
          style: 'header'
        },
        this.getPdfObject(columns, dataset),
      ],
      info: {
        title: title,
        author: title,
        subject: title,
        keywords: title,
      },
      styles: {
        header: {
          fontSize: 12,
          bold: true,
          margin: [0, 0, 0, 10],
          decoration: 'underline'
        },
        name: {
          fontSize: 12,
          bold: true
        },
        jobTitle: {
          fontSize: 12,
          bold: true,
          italics: true
        },
        sign: {
          margin: [0, 0, 0, 10],
          alignment: 'right',
          italics: true
        },
        tableHeader: {
          bold: true,
        }
      }
    };
  }

  getPdfObject(columns: string[], dataset: any[]) {
    const headerTitles = columns.map(o => {
      return [{ text: o, style: 'tableHeader' }];
    });
    const rows = dataset.map(o => {
      return Object.keys(o).map(key => {
        return o[key];
      });
    });
    return {
      table: {
        widths: ['100%'],
        body: [[headerTitles], rows.map(ed => { console.log(ed); return [ed]; })]
      }
    };
  }

 


  

}

export interface ExcelConfig {
  creator?: string;
  lastModifiedBy?: string;
  worksheetName?: string;
  views?: (Partial<ExcelJS.WorksheetViewCommon & ExcelJS.WorksheetViewNormal> | Partial<ExcelJS.WorksheetViewCommon & ExcelJS.WorksheetViewFrozen> | Partial<ExcelJS.WorksheetViewCommon & ExcelJS.WorksheetViewSplit>)[];
}

